var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "recent-docs" }, [
    _c("div", { staticClass: "recent-docs-container pt-3" }, [
      _c(
        "div",
        { staticClass: "px-3 pb-2 is-flex is-justify-content-space-between" },
        [
          _c("p", [
            _c("b", [_vm._v("Últimos documentos")]),
            _vm._v(" \n      "),
            _vm.isLoading
              ? _c("span", { staticClass: "has-text-primary is-size-7" }, [
                  _c("i", { staticClass: "fas fa-sync fa-spin fa-fw" }),
                  _vm._v(" "),
                  _c("span", {}, [_vm._v("Cargando..")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show && !_vm.isLoading
              ? _c("a", { on: { click: _vm.fetchRecentDocuments } }, [
                  _c("i", { staticClass: "fas fa-sync fa-fw" }),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ml-2" }, [
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    _vm.show = !_vm.show
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fas fa-lg",
                  class: {
                    "fa-angle-double-down": _vm.show,
                    "fa-angle-double-up": !_vm.show,
                  },
                }),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.show && _vm.isLoading
        ? _c("div", { staticClass: "px-2 pb-2" }, [
            _c("div", { staticClass: "is-flex" }, [
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c("b-skeleton", {
                    attrs: { height: "125px", width: "125px" },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show && !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "flex-container is-flex" },
            [
              _c("div", { staticClass: "pl-3" }),
              _vm._v(" "),
              _vm._l(_vm.documents, function (document) {
                return _c(
                  "div",
                  {
                    key: document.id,
                    staticClass: "document-card is-clickable",
                    on: {
                      click: function ($event) {
                        return _vm.openFile(document)
                      },
                    },
                  },
                  [
                    document.tipo_documento_id == "carpeta"
                      ? _c("div", {
                          staticClass: "background",
                          style: `background-image: url('/statics/default-folder.png')`,
                        })
                      : _c("div", {
                          staticClass: "background",
                          style: `background-image: url(${
                            document.preview_uri
                              ? document.preview_uri
                              : "/statics/default-document.png"
                          })`,
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "py-2 px-3" }, [
                      _c("p", { staticClass: "has-text-primary name-file" }, [
                        _c("b", [_vm._v(_vm._s(document.nombre))]),
                      ]),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "pl-3" }),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }